// 导出模块 路由、状态管理、国际化、侧边导航按钮

export const routerModules = {
  home: require.context('./modules/home', true, /\broutes\b\.js$/),
  demo: require.context('./modules/demo', true, /\broutes\b\.js$/),
  // test: require.context('./modules/test', true, /\broutes\b\.js$/),
  center: require.context('./modules/center', true, /\broutes\b\.js$/),
  dayjs: require.context('./modules/dayjs', true, /\broutes\b\.js$/),
  modal: require.context('./modules/modal', true, /\broutes\b\.js$/),
  comploop: require.context('./modules/comploop', true, /\broutes\b\.js$/),
  echarts: require.context('./modules/echarts', true, /\broutes\b\.js$/),
  debounce: require.context('./modules/debounce', true, /\broutes\b\.js$/),
  throttle: require.context('./modules/throttle', true, /\broutes\b\.js$/),
  aggrid: require.context('./modules/aggrid', true, /\broutes\b\.js$/),
  position: require.context('./modules/position', true, /\broutes\b\.js$/),
  calendar: require.context('./modules/calendar', true, /\broutes\b\.js$/),
  starrysky: require.context('./modules/starrysky', true, /\broutes\b\.js$/),
  texthollow: require.context('./modules/texthollow', true, /\broutes\b\.js$/),
  textshadow: require.context('./modules/textshadow', true, /\broutes\b\.js$/),
  aggridexport: require.context('./modules/aggridexport', true, /\broutes\b\.js$/),
  atomiccss: require.context('./modules/atomiccss', true, /\broutes\b\.js$/),
  aggridfilter: require.context('./modules/aggridfilter', true, /\broutes\b\.js$/),
  vuetifydateinput: require.context('./modules/vuetifydateinput', true, /\broutes\b\.js$/),
  vform: require.context('./modules/vform', true, /\broutes\b\.js$/),
  aggridcolwidth: require.context('./modules/aggridcolwidth', true, /\broutes\b\.js$/),
  particlesjs: require.context('./modules/particlesjs', true, /\broutes\b\.js$/),
  piccolor: require.context('./modules/piccolor', true, /\broutes\b\.js$/),
  "alert-msg": require.context('./modules/alert-msg', true, /\broutes\b\.js$/),
  konvajs: require.context('./modules/konvajs', true, /\broutes\b\.js$/),
  dialog: require.context('./modules/dialog', true, /\broutes\b\.js$/),
  waterprogress: require.context('./modules/waterprogress', true, /\broutes\b\.js$/),
  formsubmit: require.context('./modules/formsubmit', true, /\broutes\b\.js$/),
  text3D: require.context('./modules/text3D', true, /\broutes\b\.js$/),
  card3D: require.context('./modules/card3D', true, /\broutes\b\.js$/),
  access: require.context('./modules/access', true, /\broutes\b\.js$/),
  cssmix: require.context('./modules/cssmix', true, /\broutes\b\.js$/),
  speak: require.context('./modules/speak', true, /\broutes\b\.js$/),
  codehl: require.context('./modules/codehl', true, /\broutes\b\.js$/),
  shadow: require.context('./modules/shadow', true, /\broutes\b\.js$/),
  async: require.context('./modules/async', true, /\broutes\b\.js$/),
  promise: require.context('./modules/promise', true, /\broutes\b\.js$/),
  aggridchart: require.context('./modules/aggridchart', true, /\broutes\b\.js$/),
  aggridencapsulation: require.context('./modules/aggridencapsulation', true, /\broutes\b\.js$/),
  compencapsulation: require.context('./modules/compencapsulation', true, /\broutes\b\.js$/),
  tableheadingsticky: require.context('./modules/tableheadingsticky', true, /\broutes\b\.js$/),
  databinding: require.context('./modules/databinding', true, /\broutes\b\.js$/),
  jsClosures: require.context('./modules/js-closures', true, /\broutes\b\.js$/),
  BFC: require.context('./modules/BFC', true, /\broutes\b\.js$/),
  deepclone: require.context('./modules/deepclone', true, /\broutes\b\.js$/),
  aggridrowsort: require.context('./modules/aggridrowsort', true, /\broutes\b\.js$/),
  // sass: require.context('./modules/sass', true, /\broutes\b\.js$/),
  carousel: require.context('./modules/carousel', true, /\broutes\b\.js$/),
  noCache: require.context('./modules/no-cache', true, /\broutes\b\.js$/),
  masonry: require.context('./modules/masonry', true, /\broutes\b\.js$/),
  pullupLoad: require.context('./modules/pullup-load', true, /\broutes\b\.js$/),
  equalColumnsWithFlexbox: require.context('./modules/equal-columns-with-flexbox', true, /\broutes\b\.js$/),
  defensivecss: require.context('./modules/defensivecss', true, /\broutes\b\.js$/),
  theme: require.context('./modules/theme', true, /\broutes\b\.js$/),
  datepicker: require.context('./modules/datepicker', true, /\broutes\b\.js$/),
  aggridtabledataselect: require.context('./modules/aggridtabledataselect', true, /\broutes\b\.js$/),
  aggridcolfixed: require.context('./modules/aggridcolfixed', true, /\broutes\b\.js$/),
  equidistantObjectsWithCss: require.context('./modules/equidistant-objects-with-css', true, /\broutes\b\.js$/),
  fullBleed: require.context('./modules/full-bleed', true, /\broutes\b\.js$/),
  blendBubble: require.context('./modules/blend-bubble', true, /\broutes\b\.js$/),
  zeroWidthFilter: require.context('./modules/zero-width-filter', true, /\broutes\b\.js$/),
  zeroWidthInjector: require.context('./modules/zero-width-injector', true, /\broutes\b\.js$/),
  helloThreejs: require.context('./modules/hello-threejs', true, /\broutes\b\.js$/),
  threejs: require.context('./modules/threejs', true, /\broutes\b\.js$/),
  aggridapi: require.context('./modules/aggridapi', true, /\broutes\b\.js$/),
  jslist: require.context('./modules/jslist', true, /\broutes\b\.js$/),
  drawflow: require.context('./modules/drawflow', true, /\broutes\b\.js$/),
  interstellartravel: require.context('./modules/interstellartravel', true, /\broutes\b\.js$/),
};

// packages/haha/src/components/core/Navbar.vue
// href 优先于 linkto
export const navModules = [
  { title: "主页", icon: "mdi-home-variant-outline", linkto: "/" },
  { title: "!Demo页", icon: "mdi-teddy-bear", linkto: "/demo" },
  // { title: "小工具", icon: "mdi-pistol", href: "https://miloweimo.github.io/utilities/#/" },
  // { title: "Test", icon: "mdi-test-tube", linkto: "/test" },
  
  { title: "CSS 边框阴影", icon: "mdi-box-shadow", linkto: "/shadow" },
  { title: "CSS布局 居中", icon: "mdi-format-float-center", linkto: "/center" },
  { title: "CSS布局 BFC 块级格式化上下文", icon: "mdi-archive-arrow-up-outline", linkto: "/BFC" },
  { title: "CSS布局 等距对象", icon: "mdi-tally-mark-3", linkto: "/equidistant-objects-with-css" },
  { title: "CSS布局 full-bleed 出血布局", icon: "mdi-format-align-center", linkto: "/full-bleed" },
  { title: "CSS布局 flex等宽列布局", icon: "mdi-view-carousel", linkto: "/equal-columns-with-flexbox" },
  { title: "CSS布局 masonry瀑布流布局", icon: "mdi-waterfall", linkto: "/masonry" },
  { title: "CSS布局 瀑布流布局上拉加载", icon: "mdi-progress-upload", linkto: "/pullup-load" },
  { title: "CSS滤镜 svg交融冒泡", icon: "mdi-chart-bubble", linkto: "/blend-bubble" },
  { title: "CSS 文字镂空", icon: "mdi-format-text-variant-outline", linkto: "/texthollow" },
  { title: "CSS 文字阴影", icon: "mdi-text-shadow", linkto: "/textshadow" },
  { title: "CSS 文字3D", icon: "mdi-package", linkto: "/text3D" },
  { title: "CSS 原子化CSS", icon: "mdi-atom", linkto: "/atomiccss" },
  { title: "CSS 修改图片颜色", icon: "mdi-palette", linkto: "/piccolor" },
  { title: "CSS 卡片3D", icon: "mdi-package", linkto: "/card3D" },
  { title: "CSS 混合模式", icon: "mdi-format-color-fill", linkto: "/cssmix" },
  { title: "CSS 防御性CSS", icon: "mdi-view-carousel", linkto: "/defensivecss" },
  { title: "CSS 表格表头固定", icon: "mdi-table", linkto: "/tableheadingsticky" },
  { title: "CSS sass星空", icon: "mdi-star", linkto: "/starrysky" },
  { title: "Canvas 星空前进", icon: "mdi-star", linkto: "/interstellartravel" },
  
  { title: "JS异步操作的流程控制", icon: "mdi-sync", linkto: "/async" },
  { title: "JS闭包", icon: "mdi-close-circle-multiple-outline", linkto: "/js-closures" },
  { title: "JS对象深拷贝", icon: "mdi-content-copy", linkto: "/deepclone" },
  { title: "JS debounce防抖", icon: "mdi-timer-check", linkto: "/debouncecode" },
  { title: "JS throttle节流", icon: "mdi-timer-sand", linkto: "/throttle" },
  { title: "JS 数组", icon: "mdi-list-box", linkto: "/jslist" },

  { title: "组件化 Modal 模态弹窗", icon: "mdi-message-badge-outline", linkto: "/modal" },
  { title: "组件化 日历", icon: "mdi-calendar", linkto: "/calendar" },
  { title: "组件化 日期组件国际化", icon: "mdi-calendar", linkto: "/vuetifydateinput" },
  { title: "组件化 浮动提示条组件封装", icon: "mdi-alert", linkto: "/alert-msg" },
  { title: "组件化 封装弹窗", icon: "mdi-message", linkto: "/dialog" },
  { title: "组件化 水波进度条", icon: "mdi-water", linkto: "/waterprogress" },
  { title: "组件化 code highlight 代码高亮", icon: "mdi-code-braces-box", linkto: "/codehl" },
  { title: "组件化 组件封装传参", icon: "mdi-package-check", linkto: "/compencapsulation" },
  { title: "组件化 Vue数据绑定", icon: "mdi-update", linkto: "/databinding" },
  { title: "组件化 轮播组件carousel", icon: "mdi-view-carousel", linkto: "/carousel" },
  { title: "组件化 Vue组件循环依赖", icon: "mdi-sync", linkto: "/comploop" },
  { title: "组件化 DatePicker日期选择封装", icon: "mdi-calendar-heart", linkto: "/datepicker" },


  // { title: "echarts", icon: "mdi-chart-sankey", linkto: "/echarts" },
  // { title: "Promise", icon: "mdi-sync", linkto: "/promise" },
  // { title: "SASS", icon: "mdi-sass", linkto: "/sass" },
  { title: "WebAPI 表单submit事件", icon: "mdi-table", linkto: "/formsubmit" },
  { title: "WebAPI 文字转语音", icon: "mdi-microphone", linkto: "/speak" },
  { title: "WebAPI 网页元素位置", icon: "mdi-compass-rose", linkto: "/position" },

  { title: "JS库 Day.js 日期转换", icon: "mdi-calendar", linkto: "/dayjs" },
  { title: "JS库 particlesjs", icon: "mdi-border-inside", linkto: "/particlesjs" },
  { title: "JS库 konvajs", icon: "mdi-palette", linkto: "/konvajs" },

  { title: "Bug复现 Access模块的checkbox", icon: "mdi-shield-bug-outline", linkto: "/access" },
  { title: "Bug复现 重置表单下面的表格不显示", icon: "mdi-table", linkto: "/vform" },
  
  // 其他
  { title: "Vuetify 主题切换", icon: "mdi-palette", linkto: "/theme" },
  { title: "浏览器不缓存特定请求", icon: "mdi-numeric", linkto: "/no-cache" },
  { title: "0宽字符过滤", icon: "mdi-filter-check", linkto: "/zero-width-filter" },
  { title: "0宽字符隐写", icon: "mdi-needle", linkto: "/zero-width-injector" },

  { title: "Aggrid0x00 表格", icon: "mdi-grid", linkto: "/aggrid" },
  { title: "Aggrid0x01 导出 Excel", icon: "mdi-file", linkto: "/aggridexport" },
  { title: "Aggrid0x02 筛选、自定义分页", icon: "mdi-calendar-filter-outline", linkto: "/aggridfilter" },
  { title: "Aggrid0x03 表格记住列宽选项", icon: "mdi-table", linkto: "/aggridcolwidth" },
  { title: "Aggrid0x04 表格图表 默认柱状图+折线图", icon: "mdi-chart-sankey", linkto: "/aggridchart" },
  { title: "Aggrid0x05 表格封装", icon: "mdi-chart-scatter-plot-hexbin", linkto: "/aggridencapsulation" },
  { title: "Aggrid0x06 行排序", icon: "mdi-table", linkto: "/aggridrowsort" },
  { title: "Aggrid0x07 表格-单元格多选RangeSelection复制", icon: "mdi-table", linkto: "/aggridtabledataselect" },
  { title: "Aggrid0x08 表格-列固定", icon: "mdi-table", linkto: "/aggridcolfixed" },
  { title: "Aggrid0x09 表格常用api", icon: "mdi-table", linkto: "/aggridapi" },

  { title: "three.js0x01 helloworld", icon: "mdi-cube", linkto: "/hello-threejs" },
  { title: "three.js0x02 全屏", icon: "mdi-cube", linkto: "/threejs2" },
  { title: "three.js0x03 html语意化段落的中间显示", icon: "mdi-cube", linkto: "/threejs3" },
  { title: "three.js0x04 canvas截图", icon: "mdi-cube", linkto: "/threejs4" },
  { title: "three.js0x05 画线", icon: "mdi-cube", linkto: "/threejs5" },
  { title: "three.js0x06 加载glb gltf", icon: "mdi-cube", linkto: "/threejs6" },
  { title: "three.js0x07 摄像机", icon: "mdi-cube", linkto: "/threejs7" },
  { title: "three.js0x08 文字", icon: "mdi-text", linkto: "/threejs8" },
  { title: "three.js0x09 🐎", icon: "mdi-horse-variant-fast", linkto: "/threejs9" },
  { title: "three.js0x00 Hello2", icon: "mdi-human-greeting-variant", linkto: "/threejs10" },
  { title: "three.js0x11 World App", icon: "mdi-human-greeting-variant", linkto: "/threejs11" },
  { title: "three.js0x12 PBR", icon: "mdi-light-flood-down", linkto: "/threejs12" },
  { title: "three.js0x13 transformations", icon: "mdi-cube", linkto: "/threejs13" },

  { title: "drawflow", icon: "mdi-cube", linkto: "/drawflow" },
];

export const storeModules = {
  store: require.context('./store/modules', true, /[A-Za-z0-9-_,\s]+\.js$/i),
  demo: require.context('./modules/demo/store', true, /[A-Za-z0-9-_,\s]+\.js$/i),
  "alertMsg": require.context('./modules/alert-msg/store', true, /[A-Za-z0-9-_,\s]+\.js$/i),
};

export const localeModules = {
  locales: require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i),
  demo: require.context('./modules/demo/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i),
  home: require.context('./modules/home/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i),
};
